import { PresetMedia } from '@nucleus/types/web';

export const cardBackground: PresetMedia = {
  mediaOptions: {
    blending: {
      fade: 'none',
      opacity: 0.15,
      blendMode: 'none',
      fadeIntensity: 0.35,
    },
    image: {
      tile: 'none',
      scale: 'cover',
    },
    video: {
      image: {
        tile: 'none',
        scale: 'cover',
      },
    },
    useColor: false,
  },
};
